<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <app-modal-back
        icon="close"
        ariaLabel="close"
      ></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="assessmentData">
    <div class="mable-section ion-margin-top">
      <mable-heading
        heading="h2"
        headingStyle="h1"
      >
        How are you going with {{ assessmentData.agreement.otherUser.firstName }}?
      </mable-heading>

      <div class="sub-section">
        <mable-heading
          heading="h3"
          headingStyle="h2"
        >
          How well does your worker
        </mable-heading>

        <form
          [formGroup]="form"
          novalidate
        >
          <mable-input
            label="Turn up on time for sessions?"
            [hasError]="form.get('onTimeScore').showError()"
            [noBorder]="true"
          >
            <p class="description">Including providing enough notice for changes</p>
            <star-rating
              (ratingEvent)="form.get('onTimeScore').setValue($event)"
              color="orange-500"
              class="width-100"
            >
            </star-rating>
            <p
              class="warn"
              *ngIf="form.get('onTimeScore').errors?.required"
            >
              Select an option.
            </p>
          </mable-input>

          <mable-input
            label="Complete support tasks?"
            [hasError]="form.get('taskCompletionScore').showError()"
            [noBorder]="true"
          >
            <p class="description">as agreed and instructed with acceptable standards</p>
            <star-rating
              (ratingEvent)="form.get('taskCompletionScore').setValue($event)"
              color="orange-500"
              class="width-100"
            >
            </star-rating>
            <p
              class="warn"
              *ngIf="form.get('taskCompletionScore').errors?.required"
            >
              Select an option.
            </p>
          </mable-input>

          <mable-input label="Any other feedback? (optional)">
            <ion-textarea
              formControlName="otherFeedback"
              autocapitalize="sentences"
              autosize
              rows="4"
            >
            </ion-textarea>
          </mable-input>

          <ion-item
            lines="none"
            class="mb-checkbox"
          >
            <ion-checkbox
              slot="start"
              labelPlacement="end"
              justify="start"
              formControlName="optOutOfFutureNotifications"
            >
              <span class="ion-text-wrap">I would like to opt-out of the monthly assessment after this </span>
            </ion-checkbox>
          </ion-item>
        </form>
      </div>
    </div>
  </ng-container>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <mable-button
          category="outline"
          expand="block"
          (onClick)="openCancelModal()"
        >
          Back
        </mable-button>
      </ion-col>
      <ion-col>
        <mable-button
          expand="block"
          (onClick)="submitEvaluation()"
        >
          Submit
        </mable-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
